//This file is used to configure cometd and define its related functions for subscribing and publishing
//Imports section
import cometdLib from "cometd";
import HWUser from "../Simplify360Chat/HWLibrary/HWUser";
import uuid from "react-uuid";
import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";
import { isNullOrUndefined } from "../Simplify360Chat/HWLibrary/HWUtils";
var tempRef = null;

export const CometdActions = (refElement) => {
  if (refElement !== undefined && refElement !== null) {
    tempRef = refElement;
  }
  console.log("refElement", refElement, tempRef);
  //Variable declaration
  const cometd = new cometdLib.CometD();
  const host = s360ConfigService.config.host;
  console.log("ENVIRONMANET", host);
  //   let listOfComponentsToUpdate = ["ConversationPage","LandingPage"];
  let connectionURL = `https://${host}/bmcometd/cometd`;
  let sendURl = "/cometd-server-channel";
  //   let recieveURL = `/${listenChannel}`;
  var additional = {
    ext: { "com.inrev.authn": { user: "cometuser1", token: "adfwew283292" } },
  };

  //cometd configuration
  cometd.websocketEnabled = true;
  console.log("COMETD-LOG:CONFIGURING COMETD FOR SENDING", connectionURL);
  cometd.configure({
    url: connectionURL.trim(),
  });

  cometd.addListener("/meta/disconnect", function (message) {
    cometd.handshake(additional, function (handshakeReply) {
      if (handshakeReply.successful) {
        console.log("COMETD-LOG:HANDSHAKE SUCCESSFULL", refElement, tempRef);
      } else {
        console.error("COMETD-LOG:HANDHSAKE FAILED");
      }
    });
  });
  //cometd handshake
  cometd.handshake(additional, function (handshakeReply) {
    if (handshakeReply.successful) {
      console.log("COMETD-LOG:HANDSHAKE SUCCESSFULL", refElement);
    } else {
      console.error("COMETD-LOG:HANDHSAKE FAILED", tempRef);
      tempRef?.actions?.handleShowReloadPopup();
    }
  });

  //cometd subscribe

  const sendMessage = (sessionId, messageData, convoType) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    const customerLastName = HWUser.customerLastName();
    const appId = HWUser.appId();
    console.log("messageData.id", messageData.id)
    const msgId = messageData.id;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "CUSTOMER_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CUSTOMER_REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const sendAckAgentMessage = (sessionId, messageData, convoType) => {
    console.log(
      "sendAckBotMessagesendAckBotMessage",
      sessionId,
      messageData,
      convoType
    );
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    const customerLastName = HWUser.customerLastName();
    const appId = HWUser.appId();
    const msgId = messageData.msgId;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "ACK_AGENT_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE ACK AGENT REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const sendBotAckMessage = (sessionId, messageData, convoType) => {
    console.log("sendBotAckMessage", sessionId, messageData, convoType);
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    const customerLastName = HWUser.customerLastName();
    const appId = HWUser.appId();
    const msgId = messageData.msgId;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "ACK_BOT_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE ACK AGENT REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const fetchConversations = (limit, lastFetchedSession) => {
    console.log("COMETD-LOG: IN FETCH CONVERSATIONS");
    const customerId = HWUser.customerId();
    const clientUser = HWUser.xmppUserName();
    const params = {
      configId: s360ConfigService.config.configId,
      command: "GET_SESSIONS_REQUEST",
      customerId,
      convoType: "TEXT",
      clientUser,
      fromUi: false,
      assignedTo: -1,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuid,
    };
    params["limit"] = limit || 30;
    params["sourceType"] = HWUser.sourceType() || 60;
    if (lastFetchedSession) {
      params["sessionInfo"] = lastFetchedSession;
    }

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR GET_SESSION_REQUEST", params);
      if (message) {
        return message;
      }
    });
  };

  const fetchHistory = (sessionInfo, fromId, limit) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      customerId,
      command: "HISTORY_REQUEST",
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      firstMessageTimestamp: 0,
      sessionInfo,
      sourceType,
      isJabber: false,
      fromApi: false,
    };
    if (fromId) {
      params["fromId"] = fromId;
    }
    if (limit) {
      params["limit"] = limit;
    }
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR HISTORY_REQUEST", params);
      if (message) {
        return message;
      }
    });
  };

  const createSession = () => {
    const customerId = HWUser.customerId();
    const clientUser = HWUser.xmppUserName();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      command: "CREATE_SESSION",
      customerId,
      convoType: "TEXT",
      clientUser,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CREATE_SESSION", params);
      if (message) {
        return message;
      }
    });
  };

  const saveUserMetaData = (userDetails, sessionId) => {
    const params = {
      sessionId: sessionId,
      command: "SAVE_USER_DETAILS",
      userDetails: userDetails,
      isJabber: false,
      fromApi: false,
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR SAVE_USER_DETAILS", params);
      if (message) {
        return message;
      }
    });
  };

  const closeSession = (sessionId) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      sessionId: sessionId,
      command: "SESSION_CLOSE_REQUEST",
      customerId,
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CLOSE_SESSION", params);
      if (message) {
        return message;
      }
    });
  };

  const changeLanguage = (sessionId, language) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      sessionId: sessionId,
      command: "CHANGE_LANGUAGE",
      customerId,
      changeLanguage: language,
      customerFirstName: s360ConfigService.config.configId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
      creator: "CUSTOMER",
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR LANGUAGE CHANGE", params);
      if (message) {
        return message;
      }
    });
  };

  const sendChatTranscript = (sessionInfo, emailId) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      sessionInfo: sessionInfo,
      emailId,
      command: "SEND_CHAT_TRANSCRIPT_REQUEST",
      customerId,
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CHAT  TRANSCRIPT", params);
      if (message) {
        return message;
      }
    });
  };

  const healthPing = (sessionId) => {
    const customerId = HWUser.customerId();
    const clientUser = HWUser.xmppUserName();

    const params = {
      configId: s360ConfigService.config.configId,
      command: "HEALTH_PING",
      customerId,
      clientUser,
      fromUi: false,
      isJabber: false,
      fromApi: false,
      sessionId: sessionId,
      sourceType: HWUser.sourceType() || 60,
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR healthPing", params);
      if (message) {
        return message;
      }
    });
  };

  const sendGif = (sessionId, messageData, convoType) => {
    console.log(sessionId, "hello");
    const customerId = HWUser.customerId();
    const clientUser = HWUser.xmppUserName();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    const customerLastName = HWUser.customerLastName();
    const pageName = HWUser.pageName();
    const appId = HWUser.appId();

    const params = {
      msgId: messageData.id,
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "CUSTOMER_REPLY",
      customerId: customerId,
      message: messageData,
      convoType: convoType,
      clientUser: clientUser,
      customerFirstName: customerFirstName,
      typing: false,
      appId: appId,
      fromUi: false,
      assignedTo: -4,
      pageName: pageName,
      firstMessageTimestamp: 0,
      sourceType: sourceType,
      isJabber: false,
      fromApi: false,
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CHAT sendGif ", params);
      if (message) {
        return message;
      }
    });
  };

  return {
    fetchConversationsCMD: fetchConversations,
    createSessionCMD: createSession,
    fetchHistoryCMD: fetchHistory,
    sendMessageCMD: sendMessage,
    saveUserMetaData: saveUserMetaData,
    closeSessionCMD: closeSession,
    changeLanguageCometd: changeLanguage,
    sendChatTranscriptCMD: sendChatTranscript,
    sendAckAgentMessage: sendAckAgentMessage,
    sendGif: sendGif,
    sendBotAckMessage: sendBotAckMessage,
    sendHealthPing: healthPing,
  };
};
